import classes from './Schedule.module.sass'
import { DaySchedule } from '../../types/interfaces'
import { weekDaysRu } from '../../utils/constants'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'
import { Button } from '../button/Button'
import { useSchedule } from './hooks/useSchedule'
import { Toggle } from '../toggle/Toggle'

export type ScheduleProps<T> = {
  title?: string
  setData: React.Dispatch<React.SetStateAction<T>>
  data: T
}

const PRESETS = [
  { label: '10-19', from: '10:00', to: '19:00' },
  { label: '9-20', from: '09:00', to: '20:00' },
  { label: '8-22', from: '08:00', to: '22:00' },
  { label: '10-20', from: '10:00', to: '20:00' },
  { label: '8-1', from: '08:00', to: '01:00' },
  { label: '8-0', from: '08:00', to: '00:00' },
  { label: '6-23', from: '06:00', to: '23:00' },
  { label: '7-21', from: '07:00', to: '21:00' },
  { label: '9-18', from: '09:00', to: '18:00' },
  { label: '11-23', from: '11:00', to: '23:00' },
  { label: 'Кругл.', from: '00:00', to: '23:59' },
]

export const Schedule = <T extends { schedule?: DaySchedule[] }>({
  title = 'Режим работы',
  data,
  setData,
}: ScheduleProps<T>) => {
  const dark = useSelector(selectDarkTheme)
  const { onChange, setPattern, sort, handleToggle } = useSchedule(setData, data)

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.list}>
        {data.schedule &&
          [...data.schedule].sort(sort).map((el) => (
            <div className={classes.row} key={el.sequence}>
              <div className={classes.toggle}>
                <Toggle
                  id={String(el.sequence)}
                  onChange={() => {
                    handleToggle(el)
                  }}
                  checked={el.dayOff === false}
                />
              </div>
              <div className={classes.day}>{weekDaysRu[el.sequence - 1]}</div>
              <div className={classes.item}>
                <input
                  disabled={el.dayOff}
                  className={!dark ? classes.input : classes.inputDark}
                  type="time"
                  value={el.from}
                  onChange={(e) => onChange(e.target.value, el, 'from')}
                />
              </div>
              -
              <div className={classes.item}>
                <input
                  disabled={el.dayOff}
                  className={!dark ? classes.input : classes.inputDark}
                  type="time"
                  value={el.to}
                  onChange={(e) => onChange(e.target.value, el, 'to')}
                />
              </div>
            </div>
          ))}
      </div>
      <div className={classes.presets}>
        {PRESETS.map((preset) => (
          <div className={classes.presetButton} key={preset.label}>
            <Button
              small
              text={preset.label}
              onClick={() => {
                setPattern({ from: preset.from, to: preset.to, dayOff: false })
              }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
